const eventsAuthNames = {
	siteVisitDemoUser: 'before-auth-page-view-web-ai',
};

export default eventsAuthNames;
